import { Menu, MenuItem, Typography, Divider, MenuList, ListItemText, IconButton, Fade } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { useTabs } from '@shared/hooks/useTabs';
import { getRecentlyClosedTabs, ITab } from '@store/reducers/tabsSlice';
import { colorTheme } from '@styles/muiTheme';

interface HistoryMenuProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  handleMenuClose: () => void;
}
export const HistoryMenu = ({ open, anchorEl, handleMenuClose }: HistoryMenuProps) => {
  const navigate = useNavigate();
  const { openTab } = useTabs();
  const recentlyClosedTabs = useSelector(getRecentlyClosedTabs) || [];

  return (
    <Menu
      id="fade-menu"
      anchorEl={anchorEl}
      open={open}
      TransitionComponent={Fade}
      slotProps={{
        paper: {
          sx: {
            width: 250,
            maxWidth: 250,
            height: 420,
            boxShadow: 10,
          },
        },
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      MenuListProps={{
        'aria-labelledby': 'recently-closed-button',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      onClose={handleMenuClose}
    >
      <MenuItem
          sx={{ 
            pointerEvents: 'none',
          }}
        >
          <Typography
            variant="h4"
            sx={{ 
              color: colorTheme.palette.text.primary,
              flexGrow: 1, 
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            Recently Closed Tabs
          </Typography>
         
          <IconButton 
            size="small" 
            sx={{ 
              pointerEvents: 'auto',
              ml: 1,
              width: 'auto',
              height: 'auto',
              color: colorTheme.palette.text.primary,
            }}
            onClick={handleMenuClose}
          >
            <CloseIcon fontSize="small" /> 
          </IconButton>
        </MenuItem>
      <Divider />
      {recentlyClosedTabs.length === 0 ? (
        <MenuItem disabled>
          <Typography sx={{ color: colorTheme.palette.text.primary }}>No recently closed tabs</Typography>
        </MenuItem>
      ) : (
        <MenuList dense>
          {recentlyClosedTabs.map(({ title, route }: ITab) => (
            <MenuItem
              key={route}
              onClick={() => {
                openTab({ title, route });
                navigate(route);
                handleMenuClose();
              }}
            >
              <ListItemText
                primaryTypographyProps={{
                  sx: {
                    fontWeight: '600',
                    whiteSpace: 'normal',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: colorTheme.palette.primary.dark,
                  },
                }}
              >
                {title}
              </ListItemText>
            </MenuItem>
          ))}
        </MenuList>
      )}
    </Menu>
  );
};
